import * as React from 'react';

import { CloseBtn } from '../../../common/components/close_button/index';
import { Modal } from '../../../common/components/modal';
import { ModalWrapper } from '../../../common/components/modal/wrapper';

import { Map } from '../../../common/components/map/';
import { IMapAreaModels } from '../../../common/components/map/index';
import { IJsonQueryGeo } from '../../../json_query';
import { TMapObjectData } from '../../state/map/map_changed';

import { MapFooterContainer } from './footer/container';

const style = require('./index.css');

export interface IMapModalProps {
  center: [number, number];
  mapRegions: IJsonQueryGeo;

  close(): void;
  onChanged(data: TMapObjectData[]): void;
  onAreaDeleted(area: TMapObjectData): void;
}

export class MapModal extends React.Component<IMapModalProps> {
  public render() {
    return (
      <ModalWrapper onClose={this.props.close}>
        <Modal
          minHeigth={200}
          minWidth={600}
          maxWidth={1192}
          width="85%"
          footer={<MapFooterContainer />}
          closeBtn={<CloseBtn onClick={this.props.close} />}
        >
          <div className={style.mapModal}>
            <Map
              onChange={this.props.onChanged}
              onDelete={this.props.onAreaDeleted}
              areaModels={this.getAreaObjects()}
              center={this.props.center}
            />
          </div>
        </Modal>
      </ModalWrapper>
    );
  }

  private getAreaObjects = (): IMapAreaModels | null => {
    if (!this.props.mapRegions) {
      return null;
    }

    const areaObjects = this.props.mapRegions.value.reduce(
      (acc: IMapAreaModels, value) => {
        switch (value.type) {
          case 'polygon':
            acc.polygons.push(value);
            break;
          case 'distance':
            acc.circles.push(value);
            break;
          default:
            break;
        }

        return acc;
      },
      {
        polygons: [],
        circles: [],
      },
    );

    return areaObjects;
  };
}
